
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-56b7b993&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./duplicateRoundtableModal.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./duplicateRoundtableModal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-56b7b993!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./duplicateRoundtableModal.vue"),
  /* scopeId */
  "data-v-56b7b993",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/duplicateRoundtableModal/duplicateRoundtableModal.vue
// module id = 164
// module chunks = 61